import React from 'react';
import ThemeToursTemplate from './ThemeToursTemplate';

const FamilyHolidays = () => {
  return <ThemeToursTemplate theme="family" />;
};

export default FamilyHolidays;
